import http from '../api/http'

export default class antiForgeryApi {
  static getAntiForgeryToken() {
    return http.get(`/api/form`)
  }
}
